export const projectKeys = {
    all: ['projects'] as const,
    lists: () => [...projectKeys.all, 'list'] as const,
    list: (filters: Record<string, unknown> = {}) => [...projectKeys.lists(), filters] as const,
    details: () => [...projectKeys.all, 'detail'] as const,
    detail: (id: string) => [...projectKeys.details(), id] as const,
    billableLineItems: (id: string) => [...projectKeys.detail(id), 'billable-line-items'] as const,
    billingTerms: (id: string) => [...projectKeys.detail(id), 'billing-terms'] as const,
}
